export default __webpack_public_path__ + "static/media/carousel-1-pic-3.337f8b43.jpg";